
import { Shield, Leaf, Users, Recycle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const EngagementCard = ({
  icon: Icon,
  title,
  description,
}: {
  icon: React.ElementType;
  title: string;
  description: string;
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
      <div className="w-12 h-12 bg-fabre-lightgreen rounded-full flex items-center justify-center mb-4">
        <Icon className="h-6 w-6 text-fabre-green" />
      </div>
      <h3 className="text-xl font-heading font-bold mb-3 text-fabre-gray">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
    </div>
  );
};

const EngagementCards = () => {
  const engagements = [
    {
      icon: Shield,
      title: "Qualité & Sécurité",
      description: "Nous appliquons des procédures rigoureuses pour garantir la qualité de nos services et la sécurité de nos opérations."
    },
    {
      icon: Leaf,
      title: "Impact Environnemental",
      description: "Nous optimisons continuellement nos processus pour réduire notre empreinte environnementale et celle de nos clients."
    },
    {
      icon: Users,
      title: "Responsabilité Sociale",
      description: "Nous favorisons l'emploi local et nous impliquons dans des initiatives sociales et éducatives dans nos territoires."
    },
    {
      icon: Recycle,
      title: "Économie Circulaire",
      description: "Nous transformons les déchets en nouvelles ressources, contribuant à une économie plus durable et circulaire."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-heading font-bold mb-2 text-fabre-gray">
            Nos Engagements
          </h2>
          <div className="w-20 h-1 bg-fabre-green mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Le développement durable est au cœur de notre activité
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {engagements.map((item, index) => (
            <EngagementCard
              key={index}
              icon={item.icon}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>

        <div className="text-center mt-8">
          <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
            <Link to="/engagements">En savoir plus sur nos engagements</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default EngagementCards;
